var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexchart',{attrs:{"type":"donut","options":_vm.options,"series":_vm.series || [0, 0, 0, 0, 0, 0, 0, 0]}})}
var staticRenderFns = []

export { render, staticRenderFns }